import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock, ArrowLeft } from "lucide-react";
import { adminLogin } from "@/lib/adminApi";
import { Starfield } from "@/components/site/Starfield";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await adminLogin(email, password);
      localStorage.setItem("rsp_token", res.access_token);
      toast.success("Welcome back, Austin.");
      nav("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-background px-6">
      <div className="grain" />
      <Starfield count={60} />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_40%,rgba(29,233,182,0.08),transparent_55%)]" />

      <a href="/" className="absolute left-6 top-6 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-slate-400 transition-colors hover:text-plasma-teal" data-testid="admin-back-home">
        <ArrowLeft className="h-3.5 w-3.5" /> Back to site
      </a>

      <form onSubmit={submit} className="glass-card relative z-10 w-full max-w-md rounded-2xl p-10" data-testid="admin-login-form">
        <div className="mb-8 flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-full border border-plasma-teal/40">
            <Lock className="h-4 w-4 text-plasma-teal" strokeWidth={1.5} />
          </span>
          <div>
            <p className="overline">Private</p>
            <h1 className="font-display text-2xl font-light text-white">Resonant Spark — Admin</h1>
          </div>
        </div>

        <label className="overline mb-2 block">Email</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          data-testid="admin-email"
          className="mb-6 w-full rounded-none border-0 border-b border-slate-700 bg-transparent px-0 py-2 font-sans text-white outline-none transition-colors focus:border-plasma-teal"
          placeholder="you@resonantsparkproject.com"
        />
        <label className="overline mb-2 block">Password</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          data-testid="admin-password"
          className="mb-8 w-full rounded-none border-0 border-b border-slate-700 bg-transparent px-0 py-2 font-sans text-white outline-none transition-colors focus:border-plasma-teal"
          placeholder="••••••••"
        />
        <button type="submit" disabled={loading} className="btn-plasma w-full justify-center disabled:opacity-60" data-testid="admin-login-submit">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" strokeWidth={1.5} />}
          {loading ? "Entering…" : "Enter"}
        </button>
      </form>
    </div>
  );
}
